import { Dispatch, FC, PropsWithChildren, SetStateAction } from 'react';
import { FormHistoryContext } from './historyTab.context';
import { FormChangesDto } from 'src/services/api/api-client';

export type HistoryTabProviderProps = {
  selectedVersion?: FormChangesDto;
  previousVersionOfSelectedVersion?: FormChangesDto;
};

export const HistoryTabProvider: FC<PropsWithChildren<HistoryTabProviderProps>> = (props) => {
  const { selectedVersion, previousVersionOfSelectedVersion } = props;

  return (
    <FormHistoryContext.Provider value={{ selectedVersion, previousVersionOfSelectedVersion }}>
      {props.children}
    </FormHistoryContext.Provider>
  );
};
